import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrow_left",
  "use": "rt-base-arrow_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-arrow_left\"><defs><style type=\"text/css\"></style></defs><path d=\"M750 217.5V140c0-6.7-7.7-10.4-12.9-6.3L286.3 486.8c-16.4 12.8-16.4 37.6 0 50.4l450.8 353.1c5.3 4.1 12.9 0.4 12.9-6.3v-77.5c0-4.9-2.3-9.6-6.1-12.6L383.9 512l360-281.9c3.8-2.9 6.1-7.6 6.1-12.6z\" p-id=\"2493\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrow_left.svg
// module id = 1246
// module chunks = 91